import React from "react";
import CorrectnessIcon from "../../../../utils/Images/CorrectnessIcon";
import VoiceAnalysisIcon from "../../../../utils/Images/VoiceAnalysisIcon";
import VisualAnalysisIcon from "../../../../utils/Images/VisualAnalysisIcon";
import ManualReviewLogo from "../../../../utils/Images/ManualReviewLogo";
// Define types for the props of AnalysisSub component
interface AnalysisSubProps {
  IconComponent: React.ComponentType<{ color: string }>;
  isActive?: boolean;
  label: string;
}

// Reusable AnalysisSub component
const AnalysisSub: React.FC<AnalysisSubProps> = ({
  IconComponent,
  isActive,
  label,
}) => {
  const color = isActive ? "var(--primary-green)" : "var(--light-grey)";

  return (
    <div>
      <div className="analysisSub">
        <IconComponent color={color} />
        <h6 style={{ color }}>{label}</h6>
      </div>
    </div>
  );
};

// Define types for the props of AnalysisRow component
interface EvaluationAttributes {
  aiAnalysis?: boolean;
  visualAnalysis?: boolean;
  audioAnalysis?: boolean;
}

interface EvaluationTypesObj {
  attributes?: EvaluationAttributes;
}

interface AnalysisRowProps {
  evaluationTypesObj?: EvaluationTypesObj;
  t: (key: string) => string;
}

// Main component
const EvaluationTypes: React.FC<AnalysisRowProps> = ({
  evaluationTypesObj,
  t,
}) => {
  const { aiAnalysis, visualAnalysis, audioAnalysis } =
    evaluationTypesObj?.attributes || {};

  return (
    <div className="row">
      <div className="col-sm-12 col-md-6 col-lg-3">
        <div className="analysisSubCard analysisActive">
          <AnalysisSub
            IconComponent={ManualReviewLogo}
            isActive={true}
            label={t("GENERAL.MANUAL_REVIEW")}
          />
          <p>{t("GENERAL.MANUAL_ANALYSIS_DESC")}</p>
        </div>
      </div>
      <div className="col-sm-12 col-md-6 col-lg-3">
        <div
          className={`analysisSubCard ${aiAnalysis === true ? "analysisActive" : ""}`}
        >
          <AnalysisSub
            IconComponent={CorrectnessIcon}
            isActive={aiAnalysis}
            label={t("RESPONSE_LIST.AI_ANALYSIS")}
          />
          <p>{t("GENERAL.AI_ANALYSIS_DESC")}</p>
        </div>
      </div>
      <div className="col-sm-12 col-md-6 col-lg-3">
        <div
          className={`analysisSubCard ${visualAnalysis === true ? "analysisActive" : ""}`}
        >
          <AnalysisSub
            IconComponent={VisualAnalysisIcon}
            isActive={visualAnalysis}
            label={t("CREATE_ASSESSMENT.LABEL_VISUAL_ANALYSIS")}
          />
          <p>{t("GENERAL.VISUAL_ANALYSIS_DESC")}</p>
        </div>
      </div>
      <div className="col-sm-12 col-md-6 col-lg-3">
        <div
          className={`analysisSubCard ${audioAnalysis === true ? "analysisActive" : ""}`}
        >
          <AnalysisSub
            IconComponent={VoiceAnalysisIcon}
            isActive={audioAnalysis}
            label={t("CREATE_ASSESSMENT.LABEL_VOICE_ANALYSIS")}
          />
          <p>{t("GENERAL.VOICE_ANALYSIS_DESC")}</p>
        </div>
      </div>
    </div>
  );
};

export default EvaluationTypes;
